export * from "./generated/graphql";

export enum AnswerType {
  Code = "code",
  Bonus = "bonus",
  Any = "any"
}
